var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSinbun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24.44px",
    height: "21.99px",
    viewBox: "0 0 24.44 21.99",
    style: {
      enableBackground: "new 0 0 24.44 21.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1C4EC1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_190",
    className: "st0",
    d: "M2.44,21.99C1.79,22,1.17,21.74,0.72,21.28C0.25,20.82-0.01,20.2,0,19.55V0l2.05,2.05L4.06,0 l2.05,2.05L8.16,0l2.02,2.05L12.22,0l2.05,2.05L16.28,0l2.05,2.05L20.37,0l2.02,2.05L24.44,0v19.55c0,1.35-1.1,2.44-2.44,2.44H2.44z  M2.44,19.55H11v-7.33H2.44V19.55z M13.44,19.55H22V17.1h-8.56L13.44,19.55z M13.44,14.66H22v-2.44h-8.56L13.44,14.66z M2.44,9.77 h19.55V6.11H2.44L2.44,9.77z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSinbun);
export default __webpack_public_path__ + "static/media/ico_sinbun.bb60fec71c6332644715ded5d247bd77.svg";
export { ForwardRef as ReactComponent };